import React from 'react';
import { Button, Typography } from 'antd';
import { SendOutlined, CaretRightOutlined } from '@ant-design/icons';
import Response from './Response';
import './responseCodeSection.css';

const { Text } = Typography;

/**
 * ResponseCodeSection - Reusable component for displaying API response
 * Shows the response data or a send request button
 *
 * @param {Object} response - The API response object
 * @param {boolean} loading - Loading state
 * @param {string} error - Error message if any
 * @param {Function} onSendRequest - Function to call when send button is clicked
 * @param {boolean} isModalTrigger - If true, shows "Try it" button styled for modal trigger
 */
const ResponseCodeSection = ({ response, loading, error, onSendRequest, isModalTrigger = false }) => {
  return (
    <div className="code-section response-code-section">
      <div className="code-section-header">
        <Text className="section-title">Response</Text>
      </div>
      <div className="code-section-body response-body">
        {!response && !loading && !error && (
          <Button
            type="primary"
            icon={isModalTrigger ? <CaretRightOutlined /> : <SendOutlined />}
            onClick={onSendRequest}
            className={isModalTrigger ? 'try-it-button' : 'send-request-button'}
            iconPosition="end"
          >
            {isModalTrigger ? 'Try it' : 'Send request'}
          </Button>
        )}
        {loading && (
          <div className="response-loading">
            <div className="loading-spinner"></div>
            <Text>Sending request...</Text>
          </div>
        )}
        {error && (
          <div className="response-error">
            <Text type="danger">{error}</Text>
          </div>
        )}
        {response && <Response loading={loading} error={error} response={response} />}
      </div>
    </div>
  );
};

export default ResponseCodeSection;
